"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ramda = require("ramda");

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _flexItem = _interopRequireDefault(require("./flex-item"));

var _utils = require("../../utils");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Pretitle = _styledComponents["default"].span.withConfig({
  displayName: "flex-block-three__Pretitle",
  componentId: "sc-y3480z-0"
})(["text-transform:uppercase;letter-spacing:4px;"]);

var descriptionFont = {
  color: "text",
  fontSize: 4,
  fontWeight: 1,
  lineHeight: [2, 2, 3, 3, 2, 2],
  textAlign: "center"
};
var pretitleFont = {
  color: "text",
  fontSize: 2,
  fontWeight: 1,
  lineHeight: 3,
  mb: 4,
  textAlign: "center"
};
var titleFont = {
  color: "title",
  fontSize: [8, 9, 11, 11, 11, 11],
  fontWeight: 2,
  lineHeight: [2, 2, 1, 1, 1, 1],
  mb: 3,
  textAlign: "center"
};
var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,
  // Background Image path
  backgroundImage: _propTypes.string,

  /** bottom padding for box* */
  bottomPadding: (0, _propTypes.arrayOf)(_propTypes.number),
  // Class name for container component
  className: _propTypes.string,
  // color prop for flex block three component
  color: _propTypes.string,
  // Custom background for container component
  customBackground: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string, _propTypes.object]),
  // Description for box
  description: _propTypes.string,
  // html id for container component
  htmlId: _propTypes.string,

  /** Image source */
  imageAbove: _propTypes.string,

  /** Image source */
  imageBelow: _propTypes.string,

  /** A boolean to set whether the dark version of the cta is used */
  itemGutter: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),

  /** setting for order of columns * */
  itemWidth: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
  // list data to create flex block three list
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    children: _propTypes.node,
    description: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    imageAbove: _propTypes.node,
    imageBelow: _propTypes.node,
    title: _propTypes.string,
    url: _propTypes.string
  })),
  // Box pretitle
  pretitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  // Theme config for flex block three list container
  theme: _utils.themePropType,

  /** Title, usually a text string, but can be a node */
  title: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Title text color override  */
  titleColor: _propTypes.string,

  /** top padding for box * */
  topPadding: (0, _propTypes.arrayOf)(_propTypes.number)
};
var defaultProps = {};

var FlexBlockThree = function FlexBlockThree(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      bottomPadding = _ref.bottomPadding,
      className = _ref.className,
      color = _ref.color,
      customBackground = _ref.customBackground,
      description = _ref.description,
      htmlId = _ref.htmlId,
      imageAbove = _ref.imageAbove,
      imageBelow = _ref.imageBelow,
      items = _ref.items,
      itemWidth = _ref.itemWidth,
      itemGutter = _ref.itemGutter,
      pretitle = _ref.pretitle,
      theme = _ref.theme,
      title = _ref.title,
      titleColor = _ref.titleColor,
      topPadding = _ref.topPadding;
  var defaultBg = "background";
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, {
    backgroundColor: backgroundColor || defaultBg,
    backgroundImage: backgroundImage,
    className: className,
    htmlId: htmlId,
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    pb: bottomPadding,
    pt: topPadding,
    width: 1
  }, (description || title || pretitle) && /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, null, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "center",
    columns: [6, 8, 8],
    flexDirection: "column",
    justifyContent: "center",
    mx: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    alignItems: "center",
    description: description,
    descriptionFont: descriptionFont,
    imageAbove: imageAbove,
    imageBelow: imageBelow,
    imageSpacing: 4,
    justifyContent: "center",
    mb: 4,
    pretitle: pretitle && /*#__PURE__*/_react["default"].createElement(Pretitle, null, pretitle),
    pretitleFont: pretitleFont,
    title: title,
    titleFont: titleFont
  }))), /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    className: className,
    id: htmlId,
    mb: theme && (0, _ramda.negate)(theme.spacings[3]),
    mx: (0, _ramda.map)(function (val) {
      return "-" + val;
    }, itemGutter) // Conteract vertical spacing on items

  }, (0, _ramda.map)(function (_ref2) {
    var children = _ref2.children,
        fDescription = _ref2.description,
        id = _ref2.id,
        fImgAbove = _ref2.imageAbove,
        fImgBelow = _ref2.imageBelow,
        fTitle = _ref2.title,
        url = _ref2.url;
    return /*#__PURE__*/_react["default"].createElement(_flexItem["default"], {
      key: id,
      color: color,
      description: fDescription,
      imageAbove: fImgAbove,
      imageBelow: fImgBelow,
      itemGutter: itemGutter,
      itemWidth: itemWidth,
      title: fTitle,
      titleColor: titleColor,
      url: url
    }, children);
  }, items))));
};

FlexBlockThree.propTypes = propTypes;
FlexBlockThree.defaultProps = defaultProps;
FlexBlockThree.displayName = "Modules.FlexBlockThree";

var _default = (0, _styledComponents.withTheme)(FlexBlockThree);

exports["default"] = _default;